import BasePage from './BasePage';
import { connect } from 'react-redux';
import configData from "../config.json";
import { setModalContent, setFiltersContent, setSelectedFilters } from '../actionCreators';
import Menu from '../components/Menu';
import Modal from '../components/Modal';
import Filters from '../components/Filters';
import Table from '../components/Table';
import Seeker from '../components/Seeker';
import $ from 'jquery';

class Bookings extends BasePage {

	loadOnConstructor() {
		this.getBookings = this.getBookings.bind(this);
		this.clickPaginationCallback = this.clickPaginationCallback.bind(this);
		this.parseBookingResponse = this.parseBookingResponse.bind(this);
		this.showFilters = this.showFilters.bind(this);
		this.filterResults = this.filterResults.bind(this);
		this.changeSeekerContent = this.changeSeekerContent.bind(this);
		this.handleSeekerChange = this.handleSeekerChange.bind(this);
		this.searchCallback = this.searchCallback.bind(this);
		this.excelExport = this.excelExport.bind(this);
		let startDate = new Date();
		let endDate = new Date();
		startDate.setDate(1);
		startDate.setHours(0);
		startDate.setMinutes(0);
		startDate.setSeconds(0);

		endDate.setMonth(endDate.getMonth() + 1);
		endDate.setDate(0);
		endDate.setHours(23);
		endDate.setMinutes(59);
		endDate.setSeconds(59);

		let filters = []
		filters.push({ name: "bookings_date_start", value: this.parseDateToString(startDate) });
		filters.push({ name: "bookings_date_end", value: this.parseDateToString(endDate) });

		this.state = {
			searchParams: filters,
			startDate,
			endDate
		};

		this.getBookings('interface');
	}

	getBookings(type) {

		const api = this.getApi();
		let apiParams = [
			{ name: 'page', value: this.state.page ? this.state.page : 1 },
			{ name: 'limit', value: configData.rowsPerPage }
		];

		if (this.state.searchParams) {
			apiParams = apiParams.concat(this.state.searchParams);
		}

		if (type === 'interface') {
			api.getBookingsInterface(apiParams, this.parseBookingResponse);
		} else if (type === 'download') {
			apiParams.push({ name: 'export_to_file', value: 1 });
			api.downloadBookings(apiParams, this.parseBookingResponse);
		} else {
			api.getBookings(apiParams, this.parseBookingResponse);
		}
	}

	handleSeekerChange(event, previousSearchValue) {

		const api = this.getApi();
		let params = [];

		['clientName_like', 'articleName_like', 'articleCode_like'].map(p => {
			return params.push({ name: p, value: event.target.value });
		});
		params.push({ name: 'conditions_type', value: 'or' });
		this.changeSeekerContent(params);

		const aditionalParams = [
			{ name: 'page', value: 1 },
			{ name: 'limit', value: configData.rowsPerPage }
		];

		params = params.concat(aditionalParams);
		if (previousSearchValue !== event.target.value) {
			params = params.map(elem => {
				if (elem.name === 'page') elem.value = 1;
				return elem;
			});
		}

		api.getBookings(params, this.searchCallback);
	}

	changeSeekerContent(newSearchParams) {
		this.setState(prevState => {
			return {
				...prevState,
				searchParams: newSearchParams
			}
		});
	}

	searchCallback(response) {
		//this.props.setUsers(response.users);
		this.setState(prevState => {
			return {
				...prevState,
				bookings: response.bookings,
				
			}
		});

	}

	parseBookingResponse(response) {

		if (response.status === 'OK') {

			this.setState(prevState => {
				return {
					...prevState,
					bookings: response.bookings,
					extra_data: response.extra_data,
					i18n: response.i18n
				}
			});

		} else if (this.state.download) {//Es download
			this.setState(prevState => {
				return {
					...prevState,
					download: 0
				}
			});

			const newBlob = new Blob([response], { type: 'application/octet-stream' });

			if (window.navigator && window.navigator.msSaveOrOpenBlob) {
				window.navigator.msSaveOrOpenBlob(newBlob);
			} else {
				// For other browsers: create a link pointing to the ObjectURL containing the blob.
				const objUrl = window.URL.createObjectURL(newBlob);

				let link = document.createElement('a');
				link.href = objUrl;
				link.download = "Reservas.xlsx";
				link.click();

				// For Firefox it is necessary to delay revoking the ObjectURL.
				setTimeout(() => { window.URL.revokeObjectURL(objUrl); }, 1000);
			}
		} else if (response.auth === false) {
			this.navigateTo('/login');
		}
	}

	clickPaginationCallback(pageNumber) {
		this.setState(prevState => {
			return {
				...prevState,
				page: pageNumber
			}
		}, this.getBookings);
	}

	showFilters() {
		let selectedFilters = {
			bookings_date: {
				start: this.props.selectedFilters.bookings_date !== undefined?
					this.props.selectedFilters.bookings_date.start: this.state.startDate, 
				end: this.props.selectedFilters.bookings_date !== undefined?
					this.props.selectedFilters.bookings_date.end:this.state.endDate,
				active: this.props.selectedFilters.bookings_date!== undefined?
					this.props.selectedFilters.bookings_date.active:true
			}
		}
		this.props.setSelectedFilters(selectedFilters);
		this.props.setFiltersContent({
			title: 'Edite sus filtros',
			users: this.state.users,
			bookings_date: { 
				start: this.props.selectedFilters.bookings_date !== undefined?
					this.props.selectedFilters.bookings_date.start: this.state.startDate, 
				end: this.props.selectedFilters.bookings_date !== undefined?
					this.props.selectedFilters.bookings_date.end:this.state.endDate,
				active: this.props.selectedFilters.bookings_date!== undefined?
					this.props.selectedFilters.bookings_date.active:true
			},
			buttons: [
				{ shown: 'Aplicar', close: true, callback: this.filterResults, behaviour: 'main' },
				{ shown: 'Cerrar', close: true }
			]
		});

		$("#filters-component").modal('toggle');
	}

	filterResults() {
		let filters = [];
		for (let prop in this.props.selectedFilters) {
			if (prop === 'bookings_date') {
				filters.push({ name: "bookings_date_start", value: this.parseDateToString(this.props.selectedFilters[prop].start) });
				filters.push({ name: "bookings_date_end", value: this.parseDateToString(this.props.selectedFilters[prop].end) });
			}
		}

		this.setState(prevState => {
			return {
				...prevState,
				page: 1,
				searchParams: filters
			}
		}, this.getBookings);
	}

	parseDateToString(date) {
		const hoursFromTimezoneOffset = (date.getTimezoneOffset() * -1) / 60;
		let dateToString = new Date(date.getTime());
		dateToString.setHours(date.getHours() + hoursFromTimezoneOffset);

		return dateToString.getUTCFullYear() + "-" +
			("0" + (dateToString.getUTCMonth() + 1)).slice(-2) + "-" +
			("0" + dateToString.getUTCDate()).slice(-2) + " " +
			("0" + dateToString.getUTCHours()).slice(-2) + ":" +
			("0" + dateToString.getUTCMinutes()).slice(-2) + ":" +
			("0" + dateToString.getUTCSeconds()).slice(-2);
	}

	excelExport(){
		this.setState(prevState => {
		return {
			...prevState,
			download: true
		}
		},this.getBookings.bind(this,'download'));
	}
	

	render() {
		return (
			<div className="container">
				<Menu />
				<h3>{this.getTrad('Administración de reservas')}</h3>
				<div className="row mb-2 mt-4">
					<div className="col-4">
						<button className="btn btn-secondary" onClick={this.showFilters}>Mostrar filtros</button>
					</div>
					<div className="col-4">
						<button className="btn btn-secondary" onClick={this.excelExport}>Exportar a excel</button>
					</div>
					<div className="col-4 text-right">
						<Seeker
							config={{
								shown: 'name',
								setHandler: this.searchCallback,
								items: this.state.bookings,
								handleChangeCallback: this.handleSeekerChange
							}}
						/>

					</div>
				</div>
				<div className="row">
					<div className="col-12">
						<Table
							config={{
								items: this.state.bookings,
								i18n: this.state.i18n !== undefined ? this.state.i18n : [],
								mapping: [
									{
										original: 'end_date', shown: 'Fecha de devolución', visible: true
									},
									{
										original: 'articleName', shown: 'Artículo', visible: true,
										click: {
											url: '/edit_article', params: [{ name: 'article_id', field: 'articleId' }]
										}
									},
									{
										original: 'articleCode', shown: 'Código', visible: true,
										click: {
											url: '/edit_article', params: [{ name: 'article_id', field: 'articleId' }]
										}
									},
									{
										original: 'clientName', shown: 'Cliente', visible: true, bold:true,
										click: {
											url: '/edit_client', params: [{ name: 'client_id', field: 'clientId' }]
										}
									},
									{ original: '_id', shown: '_id', visible: false }
								],
								/*pagination: {
									totalItems: this.state.totalItems ? this.state.totalItems : 0,
									totalPages: this.state.totalPages ? this.state.totalPages : 1,
									currentPage: this.state.currentPage ? this.state.currentPage : 1,
									callback: this.clickPaginationCallback
								}*/
							}}
						/>
					</div>
				</div>
				<Modal />
				<Filters />
			</div>
		);
	}
}

const mapStateToProps = state => {
	return {
		selectedFilters: state.selectedFilters
	};
}

const mapDispatchToProps = dispatch => {
	return {
		setModalContent(modalContent) {
			dispatch(setModalContent(modalContent));
		},
		setFiltersContent(filtersContent) {
			dispatch(setFiltersContent(filtersContent));
		},
		setSelectedFilters(selectedFilters) {
			dispatch(setSelectedFilters(selectedFilters));
		}
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(Bookings)